export class PerspectiveParagraph {
  constructor(element, vanishingPoint, anchorScroll = 0) {
    this.el = element;
    this.vp = vanishingPoint;
    this.anchorScroll = anchorScroll; // When this paragraph starts animating
  }

  update(scrollDepth = 0) {
    // Use scrollDepth relative to anchorScroll
    const relativeScroll = scrollDepth - this.anchorScroll;
    let scale = Math.exp((relativeScroll) / 1000); // Can tweak this

    this.el.style.left = `${this.vp.x}px`;
    this.el.style.top = `${this.vp.y}px`;
    this.el.style.transform = `scale(${scale})`;
    this.el.style.transformOrigin = `left top`;
    this.el.style.display = (scale < 0.01 || scale > 200) ? "none" : "block";
  }
}